module.exports = __webpack_public_path__ + "img/applogo1.f4cef372.png";